// extracted by mini-css-extract-plugin
export default {"paymentMethod":"PaymentMethod_paymentMethod","paymentMethodDescription":"PaymentMethod_paymentMethodDescription"};